import type { FC } from 'react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OneInput } from '@yy/one-ui'
import { FormItem } from '@/bizComponent/AntdForm/DynamicFormItemGroup'
import RULES from '../../../../rules'
import { useSelector } from '@/store'

interface IProps {
  defaultValue?: string
  required: boolean
  countryCode?: string
  channelCode?: string
}
const TaxNoField: FC<IProps> = (props) => {
  const { defaultValue = '', required, countryCode, channelCode } = props
  const njeCityName = useSelector((store) => store.configSlice?.njeCityName)
  const departureCity = useSelector((store) => store?.newServiceProvider?.props?.addressVO?.departure_city)

  const { t } = useTranslation()

  return (
    <FormItem
      name="provider_tax_no"
      initialValue={defaultValue}
      required={required}
      label={t('logistics.create.taxNumber')}
      rules={RULES.provider_tax_no({
        isRequired: required,
        countryCode,
        channelCode,
        departureCity,
        requireName: njeCityName,
      })}
    >
      <OneInput placeholder={t('common.input.placeholder')} />
    </FormItem>
  )
}

export default TaxNoField
